export const storeKeys = [
  {
    id: "greekhouse",
    label: "Greek House",
  },
  {
    id: "collegethread",
    label: "College Thread",
  },
  {
    id: "athletesthread",
    label: "Athletes Thread",
  },
  {
    id: "dev-athletesthread",
    label: "Dev Athletes Thread",
  },
  {
    id: "athletes-thread-high-school",
    label: "Athletes Thread High School",
  },
  {
    id: "athletes-thread-club-sports",
    label: "Athletes Thread Club Sports",
  },
  {
    id: "towsontigers",
    label: "Towson Tigers",
  },
  {
    id: "miamipc",
    label: "Miami PC",
  },
  {
    id: "gothreadly",
    label: "Go Threadly",
  },
  {
    id: "djlagway2",
    label: "DJ Lagway",
  },
  {
    id: "del-ray-urban",
    label: "Del Ray Urban",
  },
  {
    id: "texasonefund",
    label: "Texas One Fund",
  },
  {
    id: "thelankstore",
    label: "The Lank Store",
  },
  {
    id: "the-authentic-at-bryant-denny",
    label: "The Authentic Alabama",
  },
  {
    id: "state-of-connecticut",
    label: "State of Connecticut",
  },
];
